import { makeStyles } from "tss-react/mui";

import { QuizType } from "@/types/quiz";

export const useStyles = makeStyles<{
  isLeaderboardPage: boolean;
  quizType: QuizType;
}>()((theme, { isLeaderboardPage, quizType }) => ({
  header: {
    position: isLeaderboardPage ? "sticky" : "static",
    backgroundColor: "#ffffff",
    zIndex: 100,
    top: 0,
    paddingBottom: isLeaderboardPage ? 0 : theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      paddingTop: "1em",
      top: "1em",
    },
  },
  title: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: "1.5rem",
    },
  },
  subtitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(3),
  },
  subtitleText: {
    fontSize: "1.75rem",
    fontWeight: 700,
    textAlign: "center",
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.25rem",
    },
  },
  leaderboard: {
    borderTop: "1px solid #DADADA",
    paddingTop: theme.spacing(5),
    borderBottom:
      quizType === QuizType.Categorization ? "1px solid #DADADA" : "none",
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(4),
    },
  },
}));
